module.exports = __webpack_public_path__ + "8c2ade503b34e31430d6c98aa29a52a3.woff";